module.exports = __webpack_public_path__ + "static/media/stats_by_agency.fe337cb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/stats_by_agency.svg
// module id = 2720
// module chunks = 0